import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Power2, Timeline, TimelineLite, TimelineMax, TweenLite, TweenMax} from "gsap";
import {TractorBeamLayerConfig} from "../../config/TractorBeamLayerConfig";
import {TractorBeamHelper} from "../../utils/TractorBeamHelper";
import {TractorBeamGameConfig} from "../TractorBeamGameConfig";
import {TractorBeamSoundConfig} from "../TractorBeamSoundConfig";

export class TractorBeamRandomStackView extends BaseView {

    private _overlayMap:number [][];
    private _symbolMap:number [][];
    private _layer:PIXI.Container;

    private _symbolWidth:number;
    private _symbolHeight:number;

    private _reelOverlays:PIXI.Sprite [] = [];
    private _symbolOverlays:PIXI.Sprite [] = [];

    private _featureText:PIXI.Text;

    private _dimmer:PIXI.Graphics;
    private _beamUpSprite:PIXI.Sprite;
    private _cloneAttackSprite:PIXI.Sprite;

    private _beamUpAnimation:TimelineSprite;
    private _cloneAttackAnimation:TimelineSprite;

    protected _screenWidth:number;
    protected _screenHeight:number;
    protected _leftOffset:number;
    protected _topOffset:number;

    constructor(overlayMap:number [][] = [], symbolMap:number [][] = []) {
        super();

        this._overlayMap = overlayMap;
        this._symbolMap = symbolMap;
        this._symbolWidth = TractorBeamGameConfig.instance.SYMBOL_WIDTH;
        this._symbolHeight = TractorBeamGameConfig.instance.SYMBOL_HEIGHT;

        this._layer = StageManager.getLayer(TractorBeamLayerConfig.FEATURE_TEXT.name);
        this._layer.addChild(this);
    }

    initAnimations():void {

        this._dimmer = new PIXI.Graphics();
        this._dimmer.alpha = 0;
        this._dimmer.visible = false;
        this.addChild(this._dimmer);

        this.createFeatureText();
        this.createBeamUpSprite();

        this._cloneAttackAnimation = this.createCloneAttackTls();
        this._beamUpAnimation = this.createBeamEmUpTls();

        this.createConeAttackSprite();

        this.addChild(this._beamUpAnimation);
        this.addChild(this._cloneAttackAnimation);
    }

    onResize(data:IResizeData) {
        this._screenWidth = Math.ceil(data.width / this._layer.scale.x);
        this._screenHeight = Math.ceil(data.height / this._layer.scale.y);
        this._leftOffset = Math.floor(-this._layer.x / this._layer.scale.x);
        this._topOffset = Math.floor(-this._layer.y / this._layer.scale.y);

        if(data.orientation === Orientation.PORTRAIT) {
            this._beamUpAnimation.position.set(650, 450);
            this._cloneAttackAnimation.position.set(650, 450);
        } else {
            this._beamUpAnimation.position.set(650, 350);
            this._cloneAttackAnimation.position.set(650, 350);
        }


        this._dimmer.clear();
        this._dimmer.beginFill(0x333333, 0.5);
        this._dimmer.drawRect(this._leftOffset, this._topOffset, this._screenWidth, this._screenHeight);
        this._dimmer.alpha = 0;
    }

    private createFeatureText():void {
        const text:PIXI.Text = new PIXI.Text("Clone Attack!", {
            fontSize : 112,
            fill : 0xBBBBFF,
            stroke : 0xFF00FF,
            lineJoin : "bevel",
            strokeThickness : 8,
            miterLimit : 2,
            dropShadow : true,
            "dropShadowAngle" : 1.5
        });
        text.anchor.set(0.5, 0.5);
        text.x = 660;
        text.y = 300;
        this._featureText = text;
        this._featureText.visible = false;
        this.addChild(this._featureText);
    }

    private createCloneAttackTls():TimelineSprite {
        const tls:TimelineSprite = new TimelineSprite(GameResources.getTextures("cloneAttackAnimation"));

        tls.anchor.set(0.5, 0.5);
        tls.blendMode = PIXI.BLEND_MODES.SCREEN;
        //tls.playLoop();
        tls.hide();

        return tls;
    }

    private createBeamEmUpTls():TimelineSprite {
        const tls:TimelineSprite = new TimelineSprite(GameResources.getTextures("beamUpAnimation"));

        tls.anchor.set(0.5, 0.5);
        tls.blendMode = PIXI.BLEND_MODES.SCREEN;
        //tls.playLoop();
        tls.hide();

        return tls;
    }

    private createConeAttackSprite():void {
        const sprite:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("cloneAttack")[0]);

        sprite.anchor.set(0.5, 0.5);
        sprite.visible = false;

        this._cloneAttackSprite = sprite;
    }

    private createBeamUpSprite():void {
        const sprite:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("beamUp")[0]);
        sprite.anchor.set(0.5, 0.5);
        sprite.visible = false;

        this._beamUpSprite = sprite;
    }

    public playBeamEmUp(cloneAttack:boolean = false):Timeline {
        const tl:TimelineLite = new TimelineLite();
        //let sprite:PIXI.Sprite = (cloneAttack)? this._cloneAttackSprite : this._beamUpSprite;
        let tls:TimelineSprite = (cloneAttack) ? this._cloneAttackAnimation : this._beamUpAnimation;


        tl.add([
            () => {
                //sprite.alpha = 0;
                //sprite.visible = true;
                this._dimmer.visible = true;
                //this._dimmer.alpha = 0;
            },
            () => SlotGame.sound.playEffect(TractorBeamSoundConfig.instance.RANDOM_FEATURE),
            () => tls.getAnimationAutoShowHide(),
            /*() => TweenLite.fromTo(sprite, 0.2, {
                alpha: 0
            }, {
                alpha: 1
            }),*/
            () => TweenLite.fromTo(this._dimmer, 0.2, {
                alpha : 0
            }, {
                alpha : 0.5
            })
        ]);
        tl.add([
            /*() => TweenLite.fromTo(sprite, 0.2, {
                alpha: 1
            }, {
                alpha: 0
            }),*/
            () => TweenLite.fromTo(this._dimmer, 0.15, {
                alpha : 1
            }, {
                alpha : 0
            })
        ], "+=1.55");
        tl.add(() => {
            //sprite.alpha = 0;
            //sprite.visible = false;
            this._dimmer.visible = false;
        });

        return tl;
    }

    fadeOutCloneAttack():void {
        //TweenLite.to(this._cloneAttackSprite)
    }

    public playFeatureText(text:string = ""):Timeline {
        const timeline = new TimelineMax();
        const duration:number = 1;

        timeline.add([
            () => this._featureText.text = text,
            () => this._featureText.visible = true,
            () => this._featureText.scale.y = 0.1,
            () => this._featureText.alpha = 0.1,
            TweenLite.fromTo(this._featureText, duration / 2, {
                y : -(this._featureText.height + 10)
            }, {
                y : 300
            }),
            TweenLite.fromTo(this._featureText, duration / 2, {
                alpha : 0.1
            }, {
                alpha : 1
            }),
            TweenLite.fromTo(this._featureText, duration / 2, {
                ease : Power2.easeInOut,
                rotation : TractorBeamHelper.radians(-45)
            }, {
                rotation : TractorBeamHelper.radians(15)
            })
        ]);
        timeline.add(TweenLite.fromTo(this._featureText, duration / 4, {
            ease : Power2.easeInOut,
            rotation : TractorBeamHelper.radians(15)
        }, {
            rotation : TractorBeamHelper.radians(0)
        }), 0.3);
        timeline.add(TweenLite.to(this._featureText.scale, duration / 4, {
            ease : Power2.easeInOut,
            y : .7
        }));


        const bounceTimeline:Timeline = new TimelineMax({paused : true});
        const time:number = duration / 5;

        bounceTimeline.add(TweenLite.to(this._featureText.scale, time, {
            x : 1.1,
            y : .7
        }));

        bounceTimeline.add([
            TweenLite.to(this._featureText.scale, time * 2, {x : 0.9, y : 1.1})
        ]);

        bounceTimeline.add([
            TweenLite.fromTo(this._featureText.scale, time * 2, {
                x : 0.9,
                y : 1.1
            }, {
                x : 1,
                y : 1
            })
        ]);
        bounceTimeline.add([
            TweenLite.fromTo(this._featureText, time * 1.5, {
                alpha : 1
            }, {
                alpha : 0
            })
        ]);
        bounceTimeline.add(() => this._featureText.visible = false);


        timeline.add(bounceTimeline.play());

        //console.log("totaltime : " + timeline.totalDuration());

        return timeline;
    }

    private createOverlays():void {

        // Reel overlay
        this._overlayMap.forEach((firstSymbolPosition) => {
            const sprite:PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
            const pos:number [] = Helper.getSymbolPositions(firstSymbolPosition[0], firstSymbolPosition[1]);
            sprite.anchor.set(0.45, 0.175);
            sprite.tint = 0xDC00DC;
            sprite.width = this._symbolWidth;
            sprite.height = this._symbolHeight * 3;
            sprite.alpha = 0;
            sprite.position.set(pos[0], pos[1]);
            sprite.visible = false;

            this._reelOverlays.push(sprite);
            this.addChild(sprite);
        });

        // Symbol overlay
        let totalCount:number = 0;
        this._symbolMap.forEach((symbolPosition) => {
            const sprite:PIXI.Sprite = new PIXI.Sprite(); // PIXI.Texture.WHITE
            const pos:number [] = Helper.getSymbolPositions(symbolPosition[0], symbolPosition[1]);

            sprite.anchor.set(0.5, 0.5);
            sprite.width = this._symbolWidth;
            sprite.height = this._symbolHeight;
            sprite.alpha = 0;
            sprite.position.set(pos[0], pos[1]);
            sprite.visible = false;


            this._symbolOverlays.push(sprite);
            this.addChild(sprite);
            totalCount++;
        });
    }

    public highlightReel(reelID:number):Timeline {
        const timeline:TimelineMax = new TimelineMax();

        if(this._reelOverlays[reelID]) {

        }

        return timeline;
    }

    public highlightSymbol(reelID:number, symbolID:number):Timeline {
        const timeline:TimelineMax = new TimelineMax();

        return timeline;
    }


    protected shake(element:PIXI.Sprite, shakes:number, speed:number):Timeline {
        const tl = new TimelineLite();
        TweenMax.set(element, {x : "+=0"}); // this creates a full _gsTransform on element
        //var transforms = element._gsTransform;

        //store the transform values that exist before the shake so we can return to them later
        let initProps:any = {
            x : element.x,
            y : element.y,
            rotation : element.rotation
        };

        //shake a bunch of times
        for(let i = 0; i < shakes; i++) {
            tl.to(element, speed, {
                x : initProps.x + this.randomizer(-4, 4),
                y : initProps.y + this.randomizer(-2, 2),
                rotation : initProps.rotation + this.randomizer(-5, 5)
            });
        }
        //return to pre-shake values
        tl.to(element, speed, {
            x : initProps.x,
            y : initProps.y,
            scale : initProps.scale,
            rotation : initProps.rotation
        });

        return tl;
    }

    protected randomizer(max:number, min:number):number {
        return Math.random() * (max - min) + min;
    }

    public updateHoldersWithSym(symbolString:string):void {

    }
}
